import axios from 'axios';
export default {
	exists(url) {
		return axios.get('/private/searches/find-by-url', { params: { url } });
	},
	getNumberOfSavedSearches() {
		return axios.get('/private/searches/count');
	}
};
